import Helpers from "../../commons/helpers";
import MessageClient from "./MessageClient";

import { IPagedList } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { IDataCreateUpdate } from "../../containers/post/usePost";
import { ICommunityPostDetail } from "../../containers/channel/useChannel";

const CommunityPostService = {
    getPaged: async (query: {
        channelId?: string;
        isFollowing?: boolean;
        publishedStatus?: number;
        pageNumber?: number;
        pageSize?: number;
    }): Promise<IPagedList<ICommunityPostDetail>> => {
        const queryString = Helpers.handleFormatParams(query);
        const result = await MessageClient().get(`${Constants.ApiPath.POST.GET_COMMUNITY_POST_PAGED}?${queryString}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<ICommunityPostDetail> => {
        const result = await MessageClient().get(`${Constants.ApiPath.POST.GET_COMMUNITY_POST_DETAIL}/${id}`);
        return result.data.result;
    },

    create: async (data: IDataCreateUpdate) => {
        const result = await MessageClient().post(Constants.ApiPath.POST.CREATE_COMMUNITY_POST, data);
        return result.data.result;
    },

    update: async (data: IDataCreateUpdate) => {
        const result = await MessageClient().put(Constants.ApiPath.POST.UPDATE_COMMUNITY_POST, data);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.POST.DELETE}/${id}`);
        return result.data.result;
    },

    follow: async (id: string) => {
        const result = await MessageClient().post(`${Constants.ApiPath.POST.FOLLOW}/${id}`);
        return result.data.result;
    },

    unFollow: async (id: string) => {
        const result = await MessageClient().put(`${Constants.ApiPath.POST.UN_FOLLOW}/${id}`);
        return result.data.result;
    },
};

export default CommunityPostService;
